/* eslint-env browser */
import { Controller } from "stimulus";
import useEventController from "../composables/use_event_controller";

export default class extends Controller {
  static targets = ["submitButton", "enable_2fa"];

  starting2fa = false;

  initialize() {
    useEventController(this);
  }

  enable_2faTargetConnected(checkbox) {
    this.starting2fa = checkbox.checked;
    this.listenOn(checkbox, "change", () => {
      setTimeout(this.configure_2fa_modal.bind(this));
    });
  }

  configure_2fa_modal() {
    const openModal = !this.enable_2faTarget.checked || this.enable_2faTarget.checked === this.starting2fa;

    this.submitButtonTarget.dataset.action = openModal ? "" : "click->modal#open:stop";
    this.submitButtonTarget.type = openModal ? "submit" : "button";
  }
}
